import { render, staticRenderFns } from "./ReportSummaryMetrics.vue?vue&type=template&id=650b29b9&"
import script from "./ReportSummaryMetrics.vue?vue&type=script&lang=js&"
export * from "./ReportSummaryMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports